<section :class="$style.inventoryIngestionHeader" :data-qa-id="`${customClass}-header`">
    <div :class="$style.container">
        <div :class="$style.row">
            <div :class="$style.columnLeft">
                <MdTypography v-bind="{tag:'h1',variant:'heading6--medium',color:'spirits--900'}" :data-qa-id="`${customClass}-header-title`">
                    {{ title }}
                </MdTypography>
            </div>
            <div :class="$style.columnRight">
                <MdButton :class="$style.createIngestion" id="styling-with-parts" :data-qa-id="`create-${customClass}-btn`" @click="emitModal">
                    <MdIconAdd v-bind="{size:'sm',color:'white'}" slot="icon-start" :data-qa-id="`${customClass}-add`"></MdIconAdd>
                    {{ buttonText }}
                </MdButton>
            </div>
        </div>
    </div>
</section>